module.exports = __webpack_public_path__ + "img/B高通锐化25.2d9dde3d.png";